import {AuthDatasource} from "../../../data/datasources/auth-datasource";
import { makeSessionStorageAdapter } from "../adapters/session-storage-adapter-factory";

export const makeAuthDatasource = () => new AuthDatasource(
  makeSessionStorageAdapter()
)